import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import TablePagination from '@mui/material/TablePagination';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  rowsPerPageOptions = [5, 10, 25],
  sx,
  ...other
}) {
  const { count, page, rowsPerPage, onPageChange } = other;

  const totalPages = Math.ceil(count / rowsPerPage);

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        {...other}
        sx={{
          borderTopColor: 'transparent',
        }}
        ActionsComponent={() => (
          <Stack direction="row" alignItems="center" sx={{ ml: 1, mr: 1 }}>
            <IconButton
              onClick={(event) => onPageChange(event, page - 1)}
              disabled={page === 0}
              size="small"
            >
              <Iconify icon="eva:arrow-ios-back-fill" />
            </IconButton>

            <Select
              value={page}
              onChange={(event) => onPageChange(event, event.target.value)}
              size="small"
              sx={{
                mx: 1,
                height: 32,
                '& .MuiSelect-select': {
                  py: 0,
                  typography: 'body2',
                },
              }}
            >
              {[...Array(totalPages)].map((_, index) => (
                <MenuItem key={index} value={index}>
                  Page {index + 1}
                </MenuItem>
              ))}
            </Select>

            <IconButton
              onClick={(event) => onPageChange(event, page + 1)}
              disabled={page >= totalPages - 1}
              size="small"
            >
              <Iconify icon="eva:arrow-ios-forward-fill" />
            </IconButton>
          </Stack>
        )}
      />

      {onChangeDense && (
        <FormControlLabel
          label="Dense"
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}

TablePaginationCustom.propTypes = {
  dense: PropTypes.bool,
  onChangeDense: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  sx: PropTypes.object,
};
